var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApps = function SvgApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1.8,
    width: 8,
    x: 3.5,
    y: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1.8,
    width: 8,
    x: 3.5,
    y: 13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1.8,
    width: 8,
    x: 13,
    y: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 3.5H16a5 5 0 0 1 5 5v1.2a1.8 1.8 0 0 1-1.8 1.8h-4.4A1.8 1.8 0 0 1 13 9.7V5.3a1.8 1.8 0 0 1 1.8-1.8Z"
  })));
};
export default SvgApps;